import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ThemeBackdrop } from "./ThemeBackdrop";

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

// Albums-home background of the day (same for everyone on a local date), cached per day in the browser.
export const DailyBackdrop = () => {
  const day = today();
  const key = `daily-bg:${day}`;
  const [bg, setBg] = useState(() => {
    try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
  });
  useEffect(() => {
    if (bg) return;
    api.get("/daily-bg", { params: { date: day } }).then(({ data }) => {
      if (!data.background) return;
      Object.keys(localStorage).filter((k) => k.startsWith("daily-bg:")).forEach((k) => localStorage.removeItem(k));
      localStorage.setItem(key, JSON.stringify(data.background));
      setBg(data.background);
    }).catch(() => {});
  }, [bg, day, key]);
  if (!bg) return null;
  return (
    <>
      <ThemeBackdrop theme={bg} />
      <div className="daily-veil" aria-hidden data-testid="daily-backdrop" data-bg={bg.key} />
    </>
  );
};
